import React from 'react';
import { Link } from 'react-router-dom';
import { Separator } from '../ui/separator';
import { companyInfo, footerContent } from '../../data/mock';

const Footer = () => {
  return (
    <footer className="footer" style={{ backgroundColor: 'rgba(26, 58, 82, 0.98)' }}>
      <div className="container mx-auto">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Company Info */}
          <div className="lg:col-span-2">
            <img 
              src="/logo-transparent.png" 
              alt="IJSS IT Solutions"
              className="h-14 w-auto object-contain mb-4"
            />
            <p className="text-[#8899AA] text-sm leading-relaxed mb-6 max-w-md">
              {companyInfo.description}
            </p>
            <div className="flex flex-col gap-2">
              <a
                href={`mailto:${companyInfo.emails.info}`}
                className="text-[#5BB5C5] hover:text-[#7AC8D6] text-sm transition-colors"
              >
                {companyInfo.emails.info}
              </a>
              <a
                href={`mailto:${companyInfo.emails.sales}`}
                className="text-[#5BB5C5] hover:text-[#7AC8D6] text-sm transition-colors"
              >
                {companyInfo.emails.sales}
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-[#5BB5C5] font-medium text-sm mb-4">
              Navigation
            </h4>
            <nav className="flex flex-col gap-3">
              {['About', 'Services', 'Industries', 'Clients', 'Team', 'Contact'].map((item) => (
                <Link
                  key={item}
                  to={`/#${item.toLowerCase()}`}
                  className="text-[#8899AA] hover:text-[#5BB5C5] text-sm transition-colors"
                >
                  {item}
                </Link>
              ))}
            </nav>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-[#5BB5C5] font-medium text-sm mb-4">
              Services
            </h4>
            <nav className="flex flex-col gap-3">
              <span className="text-[#E8B86D] text-xs font-medium">Primary - SAP MDG</span>
              <span className="text-[#8899AA] text-xs">MDG Consulting</span>
              <span className="text-[#8899AA] text-xs">MDG Implementation</span>
              <span className="text-[#8899AA] text-xs">MDG Audit & Remediation</span>
              <span className="text-[#8899AA] text-xs">MDG AMS Support</span>
              <span className="text-[#E8B86D] text-xs font-medium mt-2">Supporting Services</span>
              <span className="text-[#8899AA] text-xs">S/4HANA & Fiori</span>
              <span className="text-[#8899AA] text-xs">Software & DevOps</span>
            </nav>
          </div>
        </div>

        <Separator className="bg-[rgba(91,181,197,0.15)] mb-8" />

        {/* Legal Footer */}
        <div className="space-y-6">
          <p className="text-[#8899AA] text-xs leading-relaxed max-w-4xl">
            {footerContent.legal}
          </p>
          <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
            <p className="text-[#6A7A8A] text-xs">
              {footerContent.copyright}
            </p>
            <div className="flex gap-6">
              <span className="text-[#6A7A8A] text-xs hover:text-[#5BB5C5] cursor-pointer transition-colors">Privacy Policy</span>
              <span className="text-[#6A7A8A] text-xs hover:text-[#5BB5C5] cursor-pointer transition-colors">Terms of Service</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
